import { render, staticRenderFns } from "./plateFieldMotor.vue?vue&type=template&id=43b701fc&"
import script from "./plateFieldMotor.vue?vue&type=script&lang=js&"
export * from "./plateFieldMotor.vue?vue&type=script&lang=js&"
import style0 from "./plateFieldMotor.vue?vue&type=style&index=0&id=43b701fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports